<div class="d-flex justify-content-center align-items-center py-3 bg-light">
  <h2>Commission Details</h2>
</div>
<div class="d-flex flex-column col-12">
  <div class="container mt-3">
    <h3>Commission Records</h3>

    <table class="table table-bordered table-striped">
      <thead class="table-dark">
        <tr>
          <th>#</th>
          <th>Order ID</th>
          <th>Total Commissions</th>
          <th>Amount (Sum)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of groupedByOrder; let i = index">
          <!-- MAIN ROW -->
          <tr>
            <td>{{ i + 1 + page * size }}</td>

            <td>
              <a href="/orders/details/{{ group.orderId }}" target="_blank">
                {{ group.orderId }}
              </a>
            </td>

            <td>{{ group.records.length }}</td>

            <td>₹{{ sumCommission(group.records) | number : "1.2-2" }}</td>

            <td>
              <button
                class="btn btn-sm btn-primary"
                (click)="toggleView(group.orderId)"
              >
                {{ expanded[group.orderId] ? "Hide" : "View More" }}
              </button>
            </td>
          </tr>

          <!-- EXPANDED ROW (now group is valid!) -->
          <tr *ngIf="expanded[group.orderId]" class="bg-light">
            <td colspan="5">
              <table class="table table-sm table-bordered mb-0">
                <thead class="table-secondary">
                  <tr>
                    <th>Role</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Remarks</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let c of group.records">
                    <td>{{ c.role }}</td>

                    <td>₹{{ c.commissionAmount | number : "1.2-2" }}</td>

                    <td>
                      <span class="badge bg-primary">{{ c.status }}</span>
                    </td>

                    <td>{{ c.createdAt | date : "dd/MM/yyyy" }}</td>

                    <td>
                      <button
                        class="btn btn-primary p-0"
                        (click)="viewRemarks(c.id)"
                      >
                        View Remarks
                      </button>
                    </td>

                    <td>
                      <button
                        class="btn btn-sm btn-success"
                        (click)="openEditModal(c)"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div
      class="modal"
      tabindex="-1"
      *ngIf="selectedCommission"
      style="display: block; background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Edit Commission</h5>
            <button class="btn-close" (click)="closeModal()"></button>
          </div>

          <div class="modal-body">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="editStatus">
              <option value="ASSIGNED">ASSIGNED</option>
              <option value="WITHDRAWAL_REQUESTED">WITHDRAWAL_REQUESTED</option>
              <option value="WITHDRAWAL_APPROVED">WITHDRAWAL_APPROVED</option>
              <option value="WITHDRAWAL_COMPLETED">WITHDRAWAL_COMPLETED</option>
              <option value="CANCELLED">CANCELLED</option>
              <option value="OUTSTANDING_ORDER">OUTSTANDING_ORDER</option>
            </select>

            <label class="form-label mt-3">Remarks</label>
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="editRemark"
            ></textarea>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" (click)="closeModal()">
              Cancel
            </button>
            <button class="btn btn-primary" (click)="updateCommission()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template
      #remarksModal
      tabindex="-1"
      aria-labelledby="remarksModal"
      aria-hidden="true"
      z-index="1150"
    >
      <div
        class="d-flex col-12 p-3 border-bottom justify-content-center align-items-center"
      >
        <div class="d-flex justify-content-between align-items-center col-11">
          <h5 class="modal-title">Remarks</h5>
          <button
            type="button"
            class="btn-close"
            (click)="closeModal()"
          ></button>
        </div>
      </div>

      <div class="modal-body">
        <div *ngIf="existingRemarks.length === 0">No remarks found.</div>

        <ul *ngIf="existingRemarks" class="list-group">
          <li class="list-group-item" *ngFor="let r of existingRemarks">
            <b>{{ r.addedBy }}</b> —
            {{ r.createdAt | date : "dd/MM/yyyy HH:mm" }}
            <br />
            {{ r.remarks }}
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
</div>
